const registrationValidation = (data)=>
{
    const errors = {};
    const Regex = /^(?:(?:\+|0{0,2})91(\s*[\-]\s*)?|[0]?)?[6789]\d{9}$/;
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (!data.dname) {
      errors.erdname = 'Name field is required';
    }

    if (!data.demail) {
        errors.erdemail = 'Emial field is required';
      }

      if (data.demail) {
        if (!emailRegex.test(data.demail)) {
            errors.erdemail = 'Invalid email ';
        
          }
      }


      if (!data.dphone) {
        errors.erdphone = 'Phone no field is required';
      }



      if (data.dphone) {
        if (!Regex.test(data.dphone)) {
          errors.erdphone = 'Invalid mobile number';
      
        }
      }



      if (!data.dqualification) {
        errors.erdqualification = 'qualification  field is required';
      }
      if (!data.daddqualification) {
        errors.erdaddqualification = 'additional  qualification  field is required';
      }
      
      if (!data.dspecialization) {
        errors.erdspecialization = 'specialization  field is required';
      }
      if (!data.dapproxhours) {
        errors.erdapproxhours = 'approx hours  field is required';
      }

      
      if (!data.dconsulttype) {
        errors.erdconsulttype = 'consult type   is required';
      }

      if (!data.dstate) {
        errors.erdstate = 'state  is required';
      }

      if (!data.dcity) {
        errors.erdcity = 'city  is required';
      }

      if (!data.dProfession) {
        errors.erdProfession = 'Profession  is required';
      }
      if (data.dacceptterms==false) {
        errors.erdacceptterms = 'Please Accept Terms And Conditions';
      }
      

    return errors

}

export default registrationValidation;